import { Form, StyledRow } from '@/components';
import { ProjectStepLookupState } from '@/redux';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import styles from './PersonalizationSummary.module.scss';

interface Props {
  name: string;
}

export const FormHomeDeadlineItem = (props: Props) => {
  const { name } = props;
  const { t } = useTranslation();
  const [{ value }] = useField<ProjectStepLookupState>(name);

  return (
    <>
      <StyledRow className={styles.date}>
        <Form.Date
          groupClassName="w-100"
          label={t('projects.details.deadlineName', { name: value.name })}
          name={`${name}.deadlineDate`}
          allowClear={false}
        />
      </StyledRow>
    </>
  );
};
